import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pic1 from '../assets/images/campus-life/pic1.webp';
import pic2 from '../assets/images/campus-life/pic2.webp';
import pic3 from '../assets/images/campus-life/pic3.webp';
import pic4 from '../assets/images/campus-life/pic4.webp';
import pic5 from '../assets/images/campus-life/pic5.webp';


function CampusLife() {
  const campusImages = [
    { id: 1, src: pic1 },
    { id: 2, src: pic2 },
    { id: 3, src: pic3 },
    { id: 4, src: pic4 },
    { id: 5, src: pic5 }
  ];

  // Custom arrow components
  const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button 
        className={className} 
        onClick={onClick} 
        aria-label="Previous"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <i className="fas fa-chevron-left"></i>
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button 
        className={className} 
        onClick={onClick} 
        aria-label="Next"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    );
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    className: "campus-slider",
    dotsClass: "slick-dots custom-dots",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: true
        }
      }
    ]
  };

  return (
    <section className="campus-life-section">
      <div className="container">
        <h2 className="section-title text-center">Campus Life</h2>
        <p className="lead text-center mb-5">Experience the vibrant academic environment at ACSR Government Medical College</p>
        
        <div className="campus-carousel-container">
          <Slider {...sliderSettings}>
            {campusImages.map((image) => (
              <div key={image.id} className="campus-slide">
                <div className="carousel-image-container">
                  <img src={image.src} alt="Campus Life" className="img-fluid rounded-lg shadow" />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default CampusLife; 